import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import SimpleTable from '../helper/SimpleTable';
import { withTranslation } from 'react-i18next';

function DetailDialog({ t, open, onClose, data, prevExists, dates }) {

    console.log(dates)
    const currentDate = dates? dates.current : 'current'
    const prevDate = dates ? dates.prev : 'prev'
  
    const tableCells2v1 = [
      { id: 'field', label: 'Field', centered: false },
      { id: 'prev', label: 'Previous Version', centered: false },
      { id: 'current', label: 'This Version', centered: false }
    ];
  
  
    const tableCells2v2 = [
      { id: 'field', label: 'Field', centered: false },
      { id: 'current', label: 'This Version', centered: false }
    ];
  
    const tableCellsDialog = prevExists ? tableCells2v1 : tableCells2v2;

    return (
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <DialogTitle id="dialog-title" > {t('UsersLog.AccountDetails')} </DialogTitle>
        <DialogContent>
          
          <SimpleTable
            data={data}
            cellKey={"field"}
            tableCells={tableCellsDialog}
            highlight="changed"
          />
  
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="contained" color="primary" >
          {t('UsersLog.Close')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  
  export default withTranslation()(DetailDialog);